import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { Button } from 'reactstrap';
import './CompanyAutoComplete.css';

class LocationAutocomplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filterLocations(searchTerm),
    };
    this.mount = React.createRef(null);
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.locations) !== JSON.stringify(prevProps.locations)) {
      if (this.mount.current)
        this.setState({
          searchTerm: '',
        });
      else {
        this.mount.current = true;
      }
    }

    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }

  filterLocations = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    const { locations } = this.props;
    return locations.filter(location => {
      return (
        !!location?.locationName &&
        location.locationName.toLowerCase().slice(0, inputLength) === inputValue
      );
    });
  };

  getLocationValue = location => location.locationName;

  renderSuggestion = location => {
    const { onRemoveLocation, onAddNewLocation } = this.props;
    const { searchTerm } = this.state;
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {location.locationName}
        {this.props.boxesLocation && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '50px',
              alignItems: 'center',
              marginRight: '5px',
            }}
          >
            <FontAwesomeIcon
              color="#fffff"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setTimeout(() => {
                  onRemoveLocation(location._id);
                }, 500);
              }}
              fixedWidth
              icon="times"
            />
            <FontAwesomeIcon
              color="#fffff"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setTimeout(() => {
                  onAddNewLocation(location);
                });
              }}
              fixedWidth
              icon="edit"
            />
          </div>
        )}
      </div>
    );
  };

  onChange = (event, { newValue }) => {
    if (newValue === '') {
      this.props.onChange({ name: 'location', value: null, suggestion: null });
    }
    this.setState({
      searchTerm: newValue,
    });

    // this.props.selectedLocationObj(newValue);
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterLocations(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onLocationSelect = (ev, { suggestion, suggestionValue }) => {
    const evObj = { name: 'location', value: suggestionValue, suggestion };
    this.props.onChange(evObj);
    if (this.props.selectedLocationObj) {
      console.log('here...inside');
      this.props.selectedLocationObj(suggestion);
    }
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      const { locations, userAutocomplete } = this.props;
      let suggestion = locations.filter(item => item.locationName === e.currentTarget.value);
      this.props.onChange({
        name: 'location',
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  locationHandler = e => {
    const { onAddNewLocation } = this.props;
    const { suggestions, searchTerm } = this.state;
    if (searchTerm) {
      onAddNewLocation(suggestions[0]);
    }
  };

  render() {
    const { searchTerm, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder:
        (this.props.fetchingLocations && 'Fetching Data...') ||
        this.props.placeholder ||
        'Search location...',
      disabled: this.props.isDisabled || false,
      value: searchTerm,
      onChange: this.onChange,
      onClick: this.locationHandler,
      onKeyPress: this.onKeyPress,
      name: 'location',
      requires: 'true',
      type: 'text',
      className: 'form-control',
      disabled: this.props.disabledAdmin || false,
    };

    // Finally, render it!
    return (
      <div className={this.props.className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getLocationValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onLocationSelect}
        />
      </div>
    );
  }
}

export default LocationAutocomplete;
